<template>
  <van-popup v-model="visible" round :style="{ width: '320px', padding: 0, top: '40%' }">
    <div class="lang-popup-bg">
      <img
        src="/img/lottery/lotterybg.png"
        style="width: 100%;height: 80%; position: absolute; top: 0; left: 0; z-index: -1;"
        alt=""
      />
    </div>
    <div class="lang-popup-header">
      <div class="lang-popup-icon">
        <img src="@/assets/global.png" style="width: 100%;height: fit-content;" alt="" />
      </div>
    </div>
    <div class="lang-popup-list">
      <div class="lang-popup-current">
        <van-icon name="info-o" size="18" color="#F29CA5" />
        {{ $t('首次登录，请选择语言') }}
      </div>
      <div
        class="lang-popup-item "
        v-for="(item, index) in langList"
        :key="item.key"
        @click="activeIndex = index"
      >
      <div>
        <img :src="item.icon" alt="" class="nation"/>
        {{ item.title }}
        </div>
        <img src="@/assets/image/check.png" v-if="activeIndex === index"/>
      </div>
    </div>
    <div class="lang-popup-footer">
      <button class="lang-popup-btn" @click="handleSetLang">{{ $t('立即切换') }}</button>
    </div>
  </van-popup>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'LanguagePopup',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      langList: [
        {
          title: 'English',
          key: 'en',
          icon: require('@/assets/image/language/en.png')
        },
        {
          title: 'Deutsch',
          key: 'de',
          icon: require('@/assets/image/language/de.png')
        },
        // {
        //   title: "français",
        //   key: "fr",
        //   icon: require("@/assets/image/language/fr.png"),
        // },
        // {
        //   title: "Русский",
        //   key: "ru",
        //   icon: require("@/assets/image/language/ru.png"),
        // },
        // {
        //   title: "Español",
        //   key: "es",
        //   icon: require("@/assets/image/language/es.png"),
        // },
        // {
        //   title: "Melayu",
        //   key: "ms",
        //   icon: require("@/assets/image/language/ms.png"),
        // },
        // {
        //   title: "繁體中文",
        //   key: "tw",
        //   icon: require("@/assets/image/language/tw.png"),
        // },
        {
          title: '简体中文',
          key: 'cn',
          icon: require('@/assets/image/language/cn.png')
        },
        // {
        //   title: "Türkçe",
        //   key: "tr",
        //   icon: require("@/assets/image/language/tr.png"),
        // },
        {
          title: '日本語',
          key: 'ja',
          icon: require('@/assets/image/language/ja.png')
        },
        {
          title: '한국어',
          key: 'ko',
          icon: require('@/assets/image/language/ko.png')
        },
        // {
        //   title: "ภาษาไทย",
        //   key: "th",
        //   icon: require("@/assets/image/language/th.png"),
        // },
        // {
        //   title: "Filipino",
        //   key: "ph",
        //   icon: require("@/assets/image/language/ph.png"),
        // },
        {
          title: 'Tiếng Việt',
          key: 'vi',
          icon: require('@/assets/image/language/vi.png')
        }
        // {
        //   title: "हिंदी",
        //   key: "hi",
        //   icon: require("@/assets/image/language/hi.png"),
        // },
        // {
        //   title: "bahasa Indonesia",
        //   key: "id",
        //   icon: require("@/assets/image/language/id.png"),
        // },
      ],
      activeIndex: 0
    }
  },
  computed: {
    ...mapGetters({
      activeLang: 'language'
    }),
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    this.activeIndex = this.langList.findIndex(item => item.key === this.activeLang)
  },
  methods: {
    ...mapMutations(['setLanguage']),
    handleSetLang() {
      const lang = this.langList[this.activeIndex].key
      this.$i18n.locale = lang
      this.setLanguage(lang)
      localStorage.setItem('firstLoad', 'false')
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped lang="less">
.lang-popup-header {
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  padding: 60px 0 50px 0;
  text-align: center;
  position: relative;
}
.lang-popup-current {
  display: flex;
  align-items: center;
  color: #555;
  font-size: 25px;
  background: transparent !important;
  margin-bottom: 8px;
  padding-left: 20px;
}
.lang-popup-icon {
  margin: 0 auto;
  width: 80px;
  height: 80px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lang-popup-list {
  background: #fff;
  padding-top: 15px;
  overflow: hidden;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.lang-popup-item {
  padding: 14px 24px;
  font-size: 28px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
  div {
    display: flex;
    align-items: center;
    img {
      width: 60px;
      height: 60px;
      margin-right: 10px;
      border-radius: 50%;
    }
  }
}
.lang-popup-item.selected {
  background: #e8f3ff;
  color: #1989fa;
  font-weight: bold;
}
.lang-popup-footer {
  padding: 20px 16px 16px 16px;
  background: #fff;
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
}
.lang-popup-btn {
  width: 100%;
  padding: 20px 0;
  background: #7E5678;
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 34px;
  font-weight: 500;
  letter-spacing: 1px;
}
</style>
